export default __webpack_public_path__ + "static/media/Dreadful-Regular.5d498c5e.ttf";